import { v4 as uuid } from "uuid";

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  {
    _id: uuid(),
    image: "https://m.media-amazon.com/images/I/716gjmLvNuL._SX679_.jpg",
    title: "Intel core i7-10700k",
    subTitle: "Intel",
    description:
      "Intel - Core i7-10700K 10th Generation 8-Core - 16-Thread - 3.8 GHz (5.1 GHz Turbo) Socket LGA1200 Unlocked Desktop Processor.",
    price: 40000,
    badge: false,
    brandName: "intel",
    categoryName: "processor",
    alt: "i7 Processor Img",
    inStock: true,
  },
  {
    _id: uuid(),
    image: "https://m.media-amazon.com/images/I/61RnzuOIOoL._SL1002_.jpg",
    title: "Intel Core i9-12900K",
    subTitle: "Intel",
    description:
      "Intel Core i9-12900K Desktop Processor 16 (8P+8E) Cores up to 5.2 GHz Unlocked LGA1700 600 Series Chipset 125W. Great performance for price.",
    price: 40000,
    badge: "New",
    brandName: "intel",
    categoryName: "processor",
    alt: "i9 Processor Img",
    inStock: true,
  },
  {
    _id: uuid(),
    title: "HyperX Fury Black 16GB 2666MHz DDR4",
    image: "https://m.media-amazon.com/images/I/61Udx3CqBtL._SL1428_.jpg",
    subTitle: "HyperX",
    description:
      "HyperX is the high-performance product division of Kingston Technology, the world’s largest independent memory manufacturer.",
    price: 9120,
    badge: false,
    brandName: "hyperx",
    categoryName: "ram",
    alt: "Ram Img",
    inStock: true,
  },
  {
    _id: uuid(),
    image: "https://m.media-amazon.com/images/I/61ATQAOa+yL._SL1000_.jpg",
    title: "HyperX Impact 16GB 2666MHz Laptop Memory",
    subTitle: "HyperX",
    description:
      "Powerful SODIMM Performance Plug N Play Automatic Overclocking Intel XMP-Ready Profiles. Plug N Play Automatic Overclocking",
    price: 7750,
    badge: "Selling Fast",
    brandName: "hyperx",
    categoryName: "ram",
    alt: "Ram Img",
    inStock: true,
  },
  {
    _id: uuid(),
    image: "https://m.media-amazon.com/images/I/91g6nUHsCLL._SL1500_.jpg",
    title: "GeForce RTX 3060 Eagle OC 12G",
    subTitle: "Nvidia",
    description:
      "GIGABYTE GeForce RTX 3060 Eagle OC 12G (REV2.0) Graphics Card, 2X WINDFORCE Fans, 12GB 192-bit GDDR6, GV-N3060EAGLE OC-12GD REV2.0 Video Card",
    price: 80000,
    badge: false,
    brandName: "nvidia",
    categoryName: "graphicsCard",
    alt: "Graphic Card Img",
    inStock: true,
  },
  {
    _id: uuid(),
    image: "https://m.media-amazon.com/images/I/81pvDYeb+qL._SL1500_.jpg",
    title: "ASUS TUF Gaming GeForce RTX™ 3060 V2 12GB",
    subTitle: "Nvidia",
    description:
      "ASUS TUF Gaming GeForce RTX™ 3060 V2 OC Edition 12GB GDDR6 Buffed-up Design LHR Graphics Card with 3 Years Warranty Triple Fan (TUF-RTX3060-O12G-V2-GAMING)",
    price: 90000,
    badge: false,
    brandName: "nvidia",
    categoryName: "graphicsCard",
    alt: "Graphic Card Img",
    inStock: false,
  },
  {
    _id: uuid(),
    image: "https://m.media-amazon.com/images/I/81a8AWjxHvL._SL1500_.jpg",
    title: "Cooler Master MasterBox TD500",
    subTitle: "Cooler Master",
    description:
      "Cooler Master MasterBox TD500 Mesh Triple ARGB Mid Tower Gaming Cabinet with Dual 360mm Radiator Support and Crystalline Tempered Glass",
    price: 8800,
    badge: "New",
    brandName: "coolerMaster",
    categoryName: "cabinet",
    alt: "Cabinet Img",
    inStock: true,
  },
  {
    _id: uuid(),
    image: "https://m.media-amazon.com/images/I/71F2FEbSaQS._SL1500_.jpg",
    title: "Cooler Master MasterBox K501L",
    subTitle: "Cooler Master",
    description:
      "Cooler Master MasterBox K501L RGB Mid Tower Gaming Cabinet with Pre-Installed Fans and Tempered Glass Side Panel",
    price: 4300,
    badge: false,
    brandName: "coolerMaster",
    categoryName: "cabinet",
    alt: "Cabinet Img",
    inStock: true,
  },
  {
    _id: uuid(),
    image: "https://m.media-amazon.com/images/I/71c1K6btzwL._SL1500_.jpg",
    title: "Corsair iCUE H115i RGB Pro XT",
    subTitle: "Corsair",
    description:
      "Corsair iCUE H115i RGB Pro XT, 280mm Radiator, Dual 140mm PWM Fans, Software Control, Liquid CPU Cooler",
    price: 11600,
    badge: "Selling Fast",
    brandName: "corsair",
    categoryName: "liquidCooler",
    alt: "Cooler Img",
    inStock: true,
  },
  {
    _id: uuid(),
    image: "https://m.media-amazon.com/images/I/515bLaqKqzL._SX679_.jpg",
    title: "Corsair Hydro H60 Liquid CPU Cooler",
    subTitle: "Corsair",
    description:
      "Precise pwm control: Dynamically adjust fan speed between 600 rpm to 1,700 rpm with a 120mm corsair sp series pwm fan, making it easy to minimize noise or maximize airflow",
    price: 5000,
    badge: false,
    brandName: "corsair",
    categoryName: "liquidCooler",
    alt: "Cooler Img",
    inStock: true,
  },
  {
    _id: uuid(),
    image: "https://m.media-amazon.com/images/I/61+U9lMboFL._SX522_.jpg",
    title: "Logitech K380 Multi-Device Bluetooth Wireless Keyboard",
    subTitle: "Logitech",
    description:
      "Logitech K380 Multi-Device Bluetooth Wireless Keyboard with Easy-Switch for Upto 3 Devices, Slim, 2 Year Battery for PC, Laptop, Windows, Mac, Chrome OS, Android, iPad OS, Apple TV (Dark Grey)",
    price: 3000,
    badge: false,
    brandName: "logitech",
    categoryName: "keyboardAndMouse",
    alt: "Keyboard Img",
    inStock: true,
  },
  {
    _id: uuid(),
    image: "https://m.media-amazon.com/images/I/61jD2DhC9zL._SL1500_.jpg",
    title: "Logitech K230 Compact Wireless Keyboard",
    subTitle: "Logitech",
    description:
      "Logitech K230 Compact Wireless Keyboard for Windows, 2.4GHz Wireless with USB Unifying Receiver, Space-Saving Design, 2-Year Battery Life, PC/Laptop- Black",
    price: 845,
    badge: false,
    brandName: "logitech",
    categoryName: "keyboardAndMouse",
    alt: "Keyboard Img",
    inStock: true,
  },
  {
    _id: uuid(),
    image: "https://m.media-amazon.com/images/I/61UxfXTUyvL._SL1500_.jpg",
    title: "Logitech G102 Light Sync Gaming Mouse",
    subTitle: "Logitech",
    description:
      "Logitech G102 Light Sync Gaming Mouse with Customizable RGB Lighting, 6 Programmable Buttons, Gaming Grade Sensor, 8 k dpi Tracking,16.8mn Color, Light Weight (Black)",
    price: 1500,
    badge: false,
    brandName: "logitech",
    categoryName: "keyboardAndMouse",
    alt: "Mouse Img",
    inStock: true,
  },
  {
    _id: uuid(),
    image: "https://m.media-amazon.com/images/I/71x15RjzfUL._SL1500_.jpg",
    title: "Logitech G402 Hyperion Fury Wired Gaming Mouse",
    subTitle: "Logitech",
    description:
      "Logitech G402 Hyperion Fury Wired Gaming Mouse, 4,000 DPI, Lightweight, 8 Programmable Buttons, Compatible with PC/Mac - Black",
    price: 2000,
    badge: false,
    brandName: "logitech",
    categoryName: "keyboardAndMouse",
    alt: "Mouse Img",
    inStock: true,
  },
  {
    _id: uuid(),
    image: "https://m.media-amazon.com/images/I/81x069mwcbL._SX522_.jpg",
    title: "ASUS ROG Strix B550-F ATX Gaming Motherboard",
    subTitle: "Asus",
    description:
      "ASUS ROG Strix B550-F Gaming WiFi 6 (AMD AM4 Socket for 3rd Gen AMD Ryzen) ATX Gaming Motherboard with PCIe 4.0, teamed Power Stages, BIOS Flashback, Dual M.2 SATA 6 Gbps USB & Aura Sync",
    price: 20500,
    badge: false,
    brandName: "asus",
    categoryName: "motherBoard",
    alt: "Motherboard Img",
    inStock: false,
  },
  {
    _id: uuid(),
    image: "https://m.media-amazon.com/images/I/71lxAerR4QL._SL1500_.jpg",
    title: "ASUS ROG X570 Crosshair VIII Formula ATX Motherboard",
    subTitle: "Asus",
    description:
      "ASUS ROG X570 Crosshair VIII Formula ATX Motherboard with PCIe 4.0, on-Board WiFi 6 (802.11Ax), 5 Gbps LAN, USB 3.2, SATA, M.2, Node and Aura Sync RGB Lighting",
    price: 52000,
    badge: false,
    brandName: "asus",
    categoryName: "motherBoard",
    alt: "Motherboard Img",
    inStock: true,
  },
  {
    _id: uuid(),
    image: "https://m.media-amazon.com/images/I/91mjQZEwqzL._SX679_.jpg",
    title: "MSI H410M PRO-VH mATX Motherboard",
    subTitle: "MSI",
    description:
      "MSI H410M PRO-VH mATX Motherboard (10th Gen Intel Core, LGA 1200 Socket, DDR4, USB 3.2 Gen 1, Intel Gigabit LAN, VGA/HDMI)",
    price: 5300,
    badge: false,
    brandName: "msi",
    categoryName: "motherBoard",
    alt: "Motherboard Img",
    inStock: false,
  },
  {
    _id: uuid(),
    image: "https://m.media-amazon.com/images/I/912u5Rc16fL._SL1500_.jpg",
    title: "MSI MPG B550 Gaming Edge",
    subTitle: "MSI",
    description:
      "MSI MPG B550 Gaming Edge WiFi AMD AM4 DDR4 M.2 USB 3.2 Gen 2 ATX Motherboard AMD Ryzen™ 5000 Series Desktop Processors",
    price: 16500,
    badge: false,
    brandName: "msi",
    categoryName: "motherBoard",
    alt: "Motherboard Img",
    inStock: true,
  },
  {
    _id: uuid(),
    image: "https://m.media-amazon.com/images/I/61NXhRCtIcL._SL1500_.jpg",
    title: "Logitech Z120 Stereo Speaker",
    subTitle: "Logitech",
    description:
      "Enjoy high-quality audio with the Logitech Z120 Stereo Speaker Set. The device produces a 1.2 W RMS audio output.",
    price: 1159,
    badge: false,
    brandName: "logitech",
    categoryName: "speaker",
    alt: "Speaker Img",
    inStock: true,
  },
  {
    _id: uuid(),
    image: "https://m.media-amazon.com/images/I/712NrHlRg2L._SL1500_.jpg",
    title: "Logitech Z623 THX 400",
    subTitle: "Logitech",
    description: "Logitech Z623 THX 400 Watt 2.1 Channel Wired Speaker (Black)",
    price: 12750,
    badge: false,
    brandName: "logitech",
    categoryName: "speaker",
    alt: "Speaker Img",
    inStock: true,
  },
  {
    _id: uuid(),
    image: "https://m.media-amazon.com/images/I/61v5KY43BmL._SL1500_.jpg",
    title: "Intel Core i9-10920X",
    subTitle: "Intel",
    description:
      "Intel Core i9-10920X Desktop Processor 12 Cores up to 4.8GHz Unlocked LGA2066 X299 Series 165W",
    price: 79990,
    badge: false,
    brandName: "intel",
    categoryName: "processor",
    alt: "i10 Processor Img",
    inStock: true,
  },
  {
    _id: uuid(),
    image: "https://m.media-amazon.com/images/I/61zpi0MigBL._SL1080_.jpg",
    title: "Intel Core i9 10850K",
    subTitle: "Intel",
    description:
      "Intel Core i9 10850K Processor 20M Cache, up to 5.20 GHz 10 Cores, 20 Threads Avenger's Edition",
    price: 31749,
    badge: false,
    brandName: "intel",
    categoryName: "processor",
    alt: "i9 Processor Img",
    inStock: true,
  },
  {
    _id: uuid(),
    image: "https://m.media-amazon.com/images/I/51leZMMlvhL._SL1000_.jpg",
    title: "G.SKILL Trident Z RGB 16GB",
    subTitle: "G.Skill",
    description:
      "G.SKILL Trident Z RGB 16GB (1 * 16GB) DDR4 3200MHz CL16-18-18-38 1.35V Desktop Memory RAM - F4-3200C16S-16GTZR",
    price: 6399,
    badge: false,
    brandName: "hyperx",
    categoryName: "ram",
    alt: "Ram Img",
    inStock: true,
  },
];
